import { Cpu } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center">
          <div className="flex items-center">
            <Cpu className="h-8 w-8 text-blue-600" />
            <span className="ml-2 text-xl font-bold text-gray-900">
              NextAPI.org
            </span>
          </div>
          {/* <div className="mt-8 flex space-x-12">
            <a href="#models" className="text-gray-600 hover:text-gray-900 font-medium">Models</a>
            <a href="#pricing" className="text-gray-600 hover:text-gray-900 font-medium">Pricing</a>
            <a href="/docs" className="text-gray-600 hover:text-gray-900 font-medium">Documentation</a>
          </div> */}
          <div className="mt-8 pt-8 border-t border-gray-200 w-full">
            <p className="text-center text-gray-600">
              © {new Date().getFullYear()} NextAPI.org. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}